module.exports = __webpack_public_path__ + "media/components/breakheader/static/surf-alert-86d9e0c905577f972f4bba876b474c6e.webp";